{
  "tabs": {
    "chat": "Чат",
    "reminders": "Ёдраскуниҳо",
    "calendar": "Тақвим",
    "settings": "Танзимот"
  },
  "common": {
    "cancel": "Бекор кардан",
    "save": "Сабт",
    "confirm": "Тасдиқ",
    "delete": "Ҳазф",
    "back": "Баргашт",
    "close": "Пӯшидан",
    "edit": "Вироят кардан",
    "search": "Ҷустуҷӯ",
    "all": "Ҳама",
    "loading": "Боргирӣ...",
    "error": "Чизе хато шуд",
    "notFound": "Пайдо нашуд",
    "tryAgain": "Лутфан дубора кӯшиш кунед",
    "retry": "Дубора",
    "undo": "Барқарор кардан",
    "pullToRefresh": "Кишидан барои навсозӣ",
    "justNow": "ҳозир"
  },
  "auth": {
    "welcome": "Хуш омадед ба FishMemory",
    "tagline": "Муовини ёдраскунии WhatsApp-и шумо, ҳоло дар ҷайбатон.",
    "subtitle": "Муовини ёдраскунии WhatsApp-и шумо, ҳоло дар ҷайбатон.",
    "phoneLabel": "Рақами WhatsApp-и шумо",
    "phoneHint": "Мо рамзи тасдиқро тавассути WhatsApp мефиристем",
    "invalidPhone": "Лутфан рақами дурусти телефонро ворид кунед",
    "continue": "Идома",
    "enterPhone": "Рақами WhatsApp-и худро ворид кунед",
    "phonePlaceholder": "Рақами телефон",
    "sendCode": "Фиристодани рамз",
    "verifyTitle": "Рақами худро тасдиқ кунед",
    "otpSentTo": "Рамзи 6 рақамӣ ба {{phone}} тавассути WhatsApp фиристода шуд",
    "enterFullCode": "Лутфан ҳамаи 6 рақамро ворид кунед",
    "invalidOtp": "Рамз нодуруст аст. Лутфан дубора кӯшиш кунед.",
    "otpFailed": "Фиристодани рамз ноком шуд. Дубора кӯшиш кунед.",
    "otpResent": "Рамз дубора фиристода шуд",
    "resendIn": "Дубора фиристодан дар {{seconds}}с",
    "resendCode": "Дубора фиристодани рамз",
    "enterOtp": "Рамзеро, ки ба WhatsApp-и шумо фиристода шудааст, ворид кунед",
    "verify": "Тасдиқ",
    "resend": "Дубора фиристодани рамз",
    "wrongNumber": "Рақам нодуруст?",
    "backToPhone": "Баргашт ба телефон",
    "editPhone": "Вироят кардани рақами телефон",
    "error": "Хато",
    "setupTitle": "Биёед танзим кунем",
    "setupSubtitle": "Шумо ҳамеша метавонед баъдан дар Танзимот тағйир диҳед",
    "namePlaceholder": "Номи шумо",
    "letsGo": "Анҷом додани танзимот",
    "skipForNow": "Ҳоло гузариш кардан"
  },
  "chat": {
    "title": "FishMemory",
    "placeholder": "Паём нависед...",
    "inputPlaceholder": "Паём нависед...",
    "typing": "FishMemory навиштан дорад...",
    "online": "Онлайн",
    "connecting": "Пайвастшавӣ...",
    "reconnecting": "Боз пайваст шудан...",
    "offline": "Офлайн",
    "empty": "Сӯҳбатро оғоз кунед",
    "emptyHint": "Ёдраскуниҳо созед, ҷадвалатонро санҷед ё кӯмак пурсед.",
    "emptyAction": "Фиристодани ёдраскунии намунавӣ",
    "actions": "Амали чат",
    "keep": "Пайвандҳоро нигоҳ доред",
    "clearTitle": "Тоза кардани чат",
    "clearConfirm": "Ҳама паёмҳоро аз ин дастгоҳ ҳазф мекунед? Ин барқарорнашаванда аст.",
    "clear": "Тоза кардани чат",
    "optionSelected": "Интихобшуда: {{label}}",
    "sendingSelection": "Фиристодан...",
    "connectionLost": "Боз пайваст шудан..."
  },
  "reminders": {
    "title": "Ёдраскуниҳои ман",
    "active": "Фаъол",
    "today": "Имрӯз",
    "thisWeek": "Ҳафтаи ҷорӣ",
    "history": "Таърих",
    "items": "мавод",
    "emptyTitle": "Ҳанӯз ёдраскуниҳо нест",
    "emptySubtitle": "Аз чат якто созед ва ин ҷо намоиш дода мешавад.",
    "emptyAction": "Кушодани чат",
    "filterActive": "Фаъол",
    "filterToday": "Имрӯз",
    "filterWeek": "Ҳафтаи ҷорӣ",
    "filterHistory": "Таърих",
    "emptyState": "Ҳанӯз ёдраскуниҳо нест. Сӯҳбатро оғоз кунед!",
    "swipeDone": "Анҷом",
    "swipeSnooze": "Танаффус",
    "swipeDelete": "Ҳазф",
    "search": "Ҷустуҷӯи ёдраскуниҳо...",
    "upcoming": "Оянда",
    "completed": "Анҷомшуда",
    "overdue": "Муқаддам",
    "tomorrow": "Фардо",
    "synced": "Ҳамоҳангшуда {{value}}",
    "swipeHint": "Барои амали бештар ёдраскуниро кашед",
    "noResults": "Ягон ёдраскунии мувофиқ нест",
    "noResultsHint": "Калимаи дигарро санҷед ё ҷустуҷӯро тоза кунед",
    "deleteAllFailed": "Ҳазфи ҳамаи ёдраскуниҳо ноком шуд"
  },
  "calendar": {
    "title": "Тақвим",
    "today": "Имрӯз",
    "tomorrow": "Фардо",
    "completed": "анҷомшуда",
    "noEvents": "Ҳеҷ чиз ба нақша гирифта нашудааст",
    "noEventsSubtitle": "Як сана интихоб кунед, то ёдраскуниҳо ва рӯйдодҳои тақвимро бинед.",
    "googleEvent": "Тақвими Google",
    "legendActive": "Фаъол",
    "legendRecurring": "Такроршаванда",
    "legendDone": "Анҷомшуда",
    "legendGoogle": "Google",
    "previousMonth": "Моҳи гузашта",
    "nextMonth": "Моҳи оянда",
    "previousYear": "Соли гузашта",
    "nextYear": "Соли оянда",
    "goToToday": "Ба имрӯз рафтан",
    "all": "Ҳама",
    "active": "Фаъол",
    "done": "Анҷомшуда",
    "paused": "Муфт"
  },
  "settings": {
    "title": "Танзимот",
    "profile": "Профил",
    "name": "Номи намоиш",
    "enterName": "Номро ворид кунед",
    "language": "Забон",
    "uiLanguage": "Забони барнома",
    "uiLanguageHelp": "Танҳо интерфейс, тамғаҳои тақвим ва самти тарҳро дар ин дастгоҳ тағйир медиҳад.",
    "serverLanguage": "Забони чат",
    "serverLanguageHelp": "Забони ҷавобҳои сервер ва паёмҳои ёдраскуниро барои ҳисоби шумо тағйир медиҳад.",
    "timezone": "Минтақаи вақт",
    "currentTimezone": "Минтақаи вақти ҷорӣ",
    "timezoneHelp": "Ҳама вақтҳои ёдраскуниҳо бо ин минтақа нишон дода мешаванд.",
    "timezonePlaceholder": "America/New_York",
    "timezoneSave": "Сабти минтақаи вақт",
    "timezoneSaved": "Минтақаи вақт навсозӣ шуд",
    "detect": "Пайдо кардан",
    "detectFailed": "Пайдо кардани минтақаи вақт ноком шуд",
    "autoDetect": "Пайдо кардани худкор аз GPS",
    "notifications": "Огоҳиномаҳо",
    "notificationsHelp": "Ёдраскуниҳои такрорӣ огоҳиномаҳои такрориро пас аз расидани ёдраскуниҳо идора мекунанд. Ҳуқуқҳои огоҳиномаро дар танзимоти телефон идора кардан мумкин аст.",
    "pushEnabled": "Огоҳиномаҳои Push",
    "autoDoneOnFire": "Автоматӣ қайд кардани анҷом",
    "autoDoneOnFireDesc": "Вақте хомӯш аст, ёдраскуниҳо фаъол мемонанд то шумо онҳоро анҷом диҳед.",
    "googleCalendar": "Тақвими Google",
    "google": "Тақвими Google",
    "googleConnected": "Пайвастшуда",
    "googleDisconnected": "Пайваст нест",
    "googleConnectedHelp": "Ёдраскуниҳои нав метавонанд ба таври худкор бо тақвими шумо ҳамоҳанг шаванд.",
    "googleDisconnectedHelp": "Тақвими Google-ро пайваст кунед, то ёдраскуниҳо ва рӯйдодҳо мувофиқ бошанд.",
    "googleConnectFailed": "Пайваст кардани Тақвими Google ноком шуд",
    "connected": "Пайвастшуда",
    "disconnected": "Пайваст нест",
    "connect": "Пайваст кардан",
    "disconnect": "Ҷудо кардан",
    "autoSync": "Ҳамоҳангсозии худкор бо ёдраскуниҳои нав",
    "autosync": "Ҳамоҳангсозии худкор бо ёдраскуниҳои нав",
    "subscription": "Обунӣ",
    "trialUsed": "Санҷиш: {{used}}/{{total}} истифода шуд",
    "trialStatus": "Санҷиш дастрас аст",
    "activeStatus": "Обунӣ фаъол",
    "expiredStatus": "Обунӣ ба поён расидааст",
    "unsubscribedStatus": "Обунӣ нест",
    "about": "Дар бораи",
    "version": "Нусха",
    "logout": "Баромадан",
    "logoutTitle": "Баромадан",
    "logoutConfirm": "Оё шумо мутмаин ҳастед, ки мехоҳед баромад кунед?",
    "noName": "Номи муайяннашуда",
    "serverConnection": "Пайвастшавӣ ба сервер",
    "serverUrl": "URL-и сервер",
    "serverEdit": "Вироят кардан",
    "saveReconnect": "Сабт ва боз пайваст шудан",
    "resetDefault": "Баргардонидани пешфарз",
    "invalidServerUrlTitle": "URL-и сервер нодуруст аст",
    "invalidServerUrlMessage": "URL-и дурусти http ё https ворид кунед, масалан https://example.com",
    "uiLanguageChangeFailed": "Таъғир додани забони барнома ноком шуд. Лутфан дубора кӯшиш кунед.",
    "serverLanguageChangeFailed": "Таъғир додани забони чат ноком шуд. Лутфан дубора кӯшиш кунед.",
    "timezoneChangeFailed": "Таъғир додани минтақаи вақт ноком шуд. Лутфан дубора кӯшиш кунед.",
    "autoSyncChangeFailed": "Навсозии ҳамоҳангсозии худкор ноком шуд. Лутфан дубора кӯшиш кунед.",
    "nameChangeFailed": "Навсозии номи намоиш ноком шуд. Лутфан дубора кӯшиш кунед.",
    "trialDays": "Free trial: {{daysLeft}} day(s) left",
    "trialEnds": "Trial ends {{date}}"
  },
  "reminder": {
    "body": "Тафсилоти ёдраскуни",
    "editTime": "Вироят кардани вақт",
    "rename": "Тағйир додани ном",
    "snooze": "Танаффус",
    "snooze15": "Танаффус 15 дақиқа",
    "pause": "Муфт кардан",
    "pauseReminder": "Муфт кардани ёдраскуни",
    "resume": "Давом додан",
    "resumeReminder": "Давом додани ёдраскуни",
    "skip": "Нигоҳ надоштан",
    "skipOccurrence": "Ин рӯйдодро гузаред",
    "syncGoogle": "Ҳамоҳангсозӣ бо Google",
    "delete": "Ҳазф",
    "deleteTitle": "Ҳазфи ёдраскуни",
    "deleteConfirm": "Ин ёдраскуни ба таври доимӣ ҳазф мешавад.",
    "deleteRecurringTitle": "Ҳазфи ёдраскуни такрорӣ",
    "deleteRecurringMessage": "Мехоҳед ин рӯйдодро гузаред ё тамоми силсиларо ҳазф кунед?",
    "deleteThisOccurrence": "Гузаронидани ин рӯйдод",
    "deleteEntireSeries": "Ҳазфи тамоми силсила",
    "done": "Анҷом",
    "markDone": "Қайд кардан ҳамчун анҷомшуда",
    "undo": "Барқарор кардан",
    "undoPrompt": "Боз фаъол кардан мехоҳед? Ҳоло барқарор кунед.",
    "recurring": "Такроршаванда",
    "nextRun": "Нақшаи оянда",
    "oneTime": "Якка маротиба",
    "pending": "Дар интизорӣ",
    "sent": "Фиристода шуд",
    "paused": "Муфтшуда",
    "active": "Фаъол",
    "snoozed": "Танаффусшуда",
    "localTime": "Бо вақти маҳаллии шумо нишон дода шудааст",
    "recurrence": "Такроршавӣ",
    "created": "Эҷодшуда",
    "tags": "Тегҳо",
    "fireCount": "Миқдори огоҳӣ",
    "actions": "Амалиёт",
    "none": "Ҳеҷ",
    "snoozeFailed": "Танаффус кардани ёдраскуни ноком шуд",
    "pauseFailed": "Муфт кардани ёдраскуни ноком шуд",
    "resumeFailed": "Давом додани ёдраскуни ноком шуд",
    "skipFailed": "Гузаронидани ёдраскуни ноком шуд",
    "doneFailed": "Қайд кардани ёдраскуни ҳамчун анҷомшуда ноком шуд",
    "undoFailed": "Барқарор кардани ҳолати ёдраскуни ноком шуд",
    "deleteFailed": "Ҳазфи ёдраскуни ноком шуд",
    "rescheduleTitle": "Бозбаҳогузорӣ?",
    "rescheduleMsg": "Ин ёдраскуни дер шудааст. Мехоҳед онро бозбаҳогузорӣ кунед?",
    "reschedule15": "Дар 15 дақиқа",
    "reschedule60": "Дар 1 соат",
    "keepOverdue": "Ҳамин тавр нигоҳ доред"
  },
  "onboarding": {
    "slide1Title": "Хуш омадед ба FishMemory",
    "slide1Sub": "Муовини ёдраскунии шахсии шумо — бо WhatsApp ва барои ҷайбати шумо сохта шудааст.",
    "slide2Title": "Танҳо табиӣ сӯҳбат кунед",
    "slide2Sub": "Ёдраскуниҳоро тавре нависед, ки фикр мекунед: \"Ба ман ёдрас кун, ки фардо соати 3 ба модарам занг занам\" — мо боқимондаро идора мекунем.",
    "slide3Title": "Ҳеҷ чизро аз даст надиҳед",
    "slide3Sub": "Огоҳиномаҳоро сари вақт гиред, бо тегҳо ташкил кунед ва ҳама чизеро, ки муҳим аст, назорат кунед.",
    "getStarted": "Оғоз кунед",
    "next": "Баъдӣ",
    "firstReminderTitle": "Аввалин ёдраскуниро созед!",
    "firstReminderHint": "Мисол нависед:",
    "firstReminderExample": "Ба ман ёдрас кун, ки фардо соати 9 субҳ об бинӯшам",
    "gotIt": "Фаҳмидам!",
    "notifRationaleTitle": "Дар вақти лозима бошед",
    "notifRationaleBody": "FishMemory барои ёдрас кардани шумо дар вақти лозима ба огоҳиномаҳо ниёз дорад. Шумо танҳо барои ёдраскуниҳое, ки худатон месозед, огоҳӣ мегиред.",
    "notifRationaleAllow": "Фаъол кардани огоҳиномаҳо",
    "notifRationaleLater": "Шояд баъдтар",
    "swipeHint": "Барои амалҳои зуд ба рост кашед →",
    "calendarDragHint": "Кишидан барои васеъ кардан ↕"
  }
}
